import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: 'ng-multiselect-dropdown'
})
export class MultiSelectDropdownFixDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('click')
  onClick() {
    setTimeout(() => this.applyFixedPosition(), 0);
  }

  private applyFixedPosition() {
    const host: HTMLElement = this.el.nativeElement;
    const dropdownList: HTMLElement | null = host.querySelector('.dropdown-list');

    if (!dropdownList) return;

    const style = window.getComputedStyle(dropdownList);

    // If hidden, wait until it becomes visible
    if (style.display === 'none' || style.visibility === 'hidden') {
      const observer = new MutationObserver((_, obs) => {
        const s = window.getComputedStyle(dropdownList);
        if (s.display !== 'none' && s.visibility !== 'hidden') {
          obs.disconnect();
          this.setPosition(dropdownList, host);
        }
      });

      observer.observe(dropdownList, { attributes: true, attributeFilter: ['style', 'class'] });
      return;
    }

    this.setPosition(dropdownList, host);
  }

 private setPosition(dropdownList: HTMLElement, host: HTMLElement) {

  const wrapper = host.closest('.dropdown-wrapper') as HTMLElement;
  const rect = (wrapper || host).getBoundingClientRect();

  this.renderer.setStyle(dropdownList, 'position', 'fixed');
  this.renderer.setStyle(dropdownList, 'top', rect.bottom + 'px');
  this.renderer.setStyle(dropdownList, 'left', rect.left + 'px');

  // ✅ outer width
  this.renderer.setStyle(dropdownList, 'width', rect.width + 'px');
  this.renderer.setStyle(dropdownList, 'min-width', rect.width + 'px');
  this.renderer.setStyle(dropdownList, 'box-sizing', 'border-box');

  // ✅ INNER WIDTH FIX (THIS IS WHAT YOU WERE MISSING)
  const listContainer = dropdownList.querySelector('ul') as HTMLElement;
  if (listContainer) {
    this.renderer.setStyle(listContainer, 'width', rect.width + 'px');
    this.renderer.setStyle(listContainer, 'min-width', rect.width + 'px');
  }

  this.renderer.setStyle(dropdownList, 'z-index', '999999');
  this.renderer.setStyle(dropdownList, 'display', 'block');
  this.renderer.setStyle(dropdownList, 'visibility', 'visible');
  this.renderer.setStyle(dropdownList, 'border', '1px solid #ccc');
  this.renderer.setStyle(dropdownList, 'box-shadow', '0 2px 5px rgba(0,0,0,0.2)');
  this.renderer.setStyle(dropdownList, 'background', '#fff');
  this.renderer.setStyle(dropdownList, 'border-radius', '2px');
 }
}
